import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { Item } from '../../../core/components/listbox/listbox.component';

@Component({
  selector: 'tt-prod-size-edit',
  templateUrl: './prod-size-edit.component.html',
  styleUrls: ['./prod-size-edit.component.css']
})
export class ProdSizeEditComponent implements OnInit {
    prodSizeKeyno;

    public selectedBgColli: string = 'COLLIINPUT';

    public edit?: Edit;

    public itemsListCollis: Item[] = [];

    public itemsListNobbs: Item[] = [];

    public itemsListColliExamples: Item[] = [];

    public saving = false;

    public creating = false;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.prodSizeKeyno = this.stateService.getStateParams()['prodsize_keyno'];
    }

    private async loadEdit() {
        if (!!this.prodSizeKeyno) {
            this.edit = (await this.datatask.Post(416, { prodsize_keyno: this.prodSizeKeyno }))[0];
        }
    }

    private async loadCollis() {
        if (!!this.edit) {
            this.itemsListCollis = await this.datatask.Post(913, { prodsize_keyno: this.edit.prodsize_keyno });
        }
    }

    private async loadNobbs() {
        if (!!this.edit) {
            this.itemsListNobbs = await this.datatask.Post(1576, { prodsize_keyno: this.edit.prodsize_keyno });
        }
    }

    private async loadColliExamples() {
        if (!!this.edit) {
            this.itemsListColliExamples = await this.datatask.Post(914, this.edit);

            this.creating = false;
        }
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                await this.datatask.Post(417, this.edit);

                this.stateService.back();
            } finally {
                this.saving = false;
            }
        }
    }

    public async createColliExample() {
        this.creating = true;
        this.loadColliExamples();
    }

    public goToFunc(state: any) {
        switch (state) {
            case 'prodsizecolli':
                this.stateService?.go('prodsizecolli', {
                    prodsize_keyno: this.edit?.prodsize_keyno,
                    prodsizecolli_keyno: '0'
                });
                break;
            default:
                break;
        }
    }

    private async init() {
        await this.loadEdit();

        if (!!this.edit) {
            if (this.edit.nbr_of_prodsizecolli === '0' && this.edit.auto_goto_prodsizecolli === '1') {
                this.stateService?.go('prodsizecolli', {
                    prodsize_keyno: this.edit.prodsize_keyno,
                    prodsizecolli_keyno: '0'
                });
            }
        }

        this.loadCollis();
        this.loadNobbs();
        this.loadColliExamples();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    prodsize_keyno: number;
    volum: string;
    weight: string;
    colli_pr_unit: number;
    purch_number_default: string;
    prodsize_heading: string;
    collicheck_info: string;
    colliexampleqty: string;
    nbr_of_prodsizecolli: string;
    auto_goto_prodsizecolli: string;
    show_setting: string;
    weight_net: string;
}
